import { ActivatedRouteSnapshot } from '@angular/router';

export const getRelayStateFromRoute = (route: ActivatedRouteSnapshot): string | undefined => {
  return route.queryParams.RelayState || undefined;
};
